import { Reveal } from "./Reveal";
import { PeakMark } from "./PeakMark";

export const Mission = () => (
  <section
    id="mission"
    data-testid="mission-section"
    className="grain relative overflow-hidden bg-evergreen text-white"
  >
    <svg
      className="absolute inset-0 h-full w-full text-leaf/10"
      viewBox="0 0 1200 600"
      preserveAspectRatio="none"
      aria-hidden="true"
    >
      {[0, 1, 2, 3, 4, 5].map((i) => (
        <line key={`h${i}`} x1="0" y1={i * 120} x2="1200" y2={i * 120} stroke="currentColor" strokeWidth="1" />
      ))}
      {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((i) => (
        <line key={`v${i}`} x1={i * 133} y1="0" x2={i * 133} y2="600" stroke="currentColor" strokeWidth="1" />
      ))}
    </svg>
    <div
      className="absolute -top-32 left-1/2 h-[420px] w-[720px] -translate-x-1/2 rounded-full bg-growth/25 blur-3xl"
      aria-hidden="true"
    />

    <div className="relative mx-auto max-w-[880px] px-4 py-24 text-center sm:px-6 lg:py-32">
      <Reveal>
        <PeakMark className="mx-auto h-10 w-auto opacity-90" />
        <p className="mt-6 font-display text-xs font-semibold uppercase tracking-[0.22em] text-leaf sm:text-sm">
          Our mission
        </p>
        <h2 className="mt-4 font-display text-4xl font-semibold tracking-tight text-white sm:text-5xl">
          Make everyday work work better.
        </h2>
        <p className="mx-auto mt-7 max-w-[680px] font-body text-lg leading-relaxed text-sage sm:text-xl">
          Our mission is to build practical products that give people back time, reduce friction,
          and make everyday work easier.
        </p>
        <p className="mx-auto mt-5 max-w-[680px] font-body text-base leading-relaxed text-sage/90">
          The best products do not invent a new problem to solve. They improve something people
          already need to do. That is the standard behind everything we build.
        </p>
      </Reveal>
    </div>
  </section>
);
